var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view',[_vm._t("default")],2),_c('notifications',{attrs:{"group":"status","animation-type":"velocity","position":"bottom right","duration":5000}}),_c('vue-confirm-dialog',{staticClass:"delete-consultified-dialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }